/**
 * 常规列表的api 之后可以不使用service的方式 直接调取接口比较简单
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getFormDetail(keyId) {
    return request(api.client.CUSTOMER + '/detail/' + keyId, METHOD.GET);
  },
  async saveFormDetail(result) {
    return request(api.client.SAVE, METHOD.POST, result);
  },
  /**
   * 同步数据
   */
  async synchronization() {
    return request(api.client.DATA_SYNC, METHOD.GET);
  },

  async sign(params) {
    return request(api.client.SIGN, METHOD.PUT, params)
  },
  async selection(params) {
    return request(api.client.SELECTION, METHOD.GET, params)
  },
  async getRepeat(params) {
    return request(api.client.CUSTOMER + '/searchRepeat?custId=' + params, METHOD.GET)
  },
  async merge(params) {
    return request(api.client.CUSTOMER + '/custMerge', METHOD.GET, params)
  },
  async selectionStrain() { //品系下拉
    return request(api.clue.CLUE + '/getStrainList', METHOD.GET)
  },
  async getDeptList() {
    return request(api.comm.DEPT, METHOD.GET);
  },
  async popSelectWithUser() {
    return request(api.comm.DEPT + '/popSelectWithUser', METHOD.GET);
  },
  async popSelect() {
    return request(api.comm.DEPT + '/popSelect', METHOD.GET);
  },
  async selectUserListByDeptId(deptId, userName) {
    return request(api.comm.USER + '/selectUserListByDeptId?deptId=' + deptId + '&userName=' + userName, METHOD.GET);
  },
  async getCommCode() {//意向品牌 品系 下拉数据
    return request(api.clue.CLUE + '/getCommCode', METHOD.GET);
  },
}

export default {dataApi}